import React from 'react';
import './HeaderDash.css';
import ButonScreen from '../ButonScreen/ButonScreen';
import InputSearch from '../InputSearch/InputSearch';
import InfoUser from '../InfoUser/InfoUser';
import ButonInstallAppNav from '../ButonInstallAppNav/ButonInstallAppNav';
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faStore } from '@fortawesome/free-solid-svg-icons';

export default function HeaderDash() {
    const handleToggleMobileSidebar = () => {
        window.dispatchEvent(new Event('toggleSidebarMobile'));
    };

    return (
        <header className="HeaderDashContain">
            <div className="headerLeftSection">
                <button
                    type="button"
                    className="btnHamburgerMobile"
                    onClick={handleToggleMobileSidebar}
                    title="Abrir menú"
                >
                    <FontAwesomeIcon icon={faBars} />
                </button>
                <InputSearch />
            </div>

            <div className="deFlexHeader">
                <Anchor to="/" className="btnTiendaHeader" title="Ver Tienda / Menú Digital" target="_blank">
                    <FontAwesomeIcon icon={faStore} /> <span className="btnTiendaText">Tienda</span>
                </Anchor>
                <ButonInstallAppNav />
                <ButonScreen />
                <InfoUser />
            </div>
        </header>
    );
}
